module.exports = __webpack_public_path__ + "img/default.bef9a95a.png";